import { render, staticRenderFns } from "./LotdNPCComponent.vue?vue&type=template&id=ac3637e4&scoped=true"
import script from "./LotdNPCComponent.vue?vue&type=script&lang=ts"
export * from "./LotdNPCComponent.vue?vue&type=script&lang=ts"
import style0 from "./LotdNPCComponent.vue?vue&type=style&index=0&id=ac3637e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3637e4",
  null
  
)

export default component.exports